import { render, staticRenderFns } from "./workTypeList.vue?vue&type=template&id=38cf66d6&scoped=true"
import script from "./workTypeList.vue?vue&type=script&lang=js"
export * from "./workTypeList.vue?vue&type=script&lang=js"
import style0 from "./workTypeList.vue?vue&type=style&index=0&id=38cf66d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf66d6",
  null
  
)

export default component.exports